import { Container, Row } from "reactstrap";
import GridOptions from "./gridOptions";
import { Grid, UIKits } from "../../../constants";
import GridColumn from "./GridColumn";
import VerticalAlignment from "./VerticalAlignment";
import HorizontalAlignment from "./HorizontalAlignment";
import Nesting from "./nesting";
import Order from "./Order";
import OffSet from "./OffSet";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const GridContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Grid} parent={UIKits} />
      <Container fluid>
        <Row>
          <GridOptions />
          <GridColumn />
          <VerticalAlignment />
          <HorizontalAlignment />
          <Nesting />
          <Order />
          <OffSet />
        </Row>
      </Container>
    </>
  );
};
export default GridContainer;
